import React, { Component } from 'react';
import config from "../../data/siteConfig"
import { Tabs, Tab } from 'react-foundation-components/lib/global/tabs';

class PackageTabs extends Component {
  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this)
    this.state = {
      activeKey: 1,
    }
  }

  handleSelect(activeKey) {
    this.setState({ activeKey })
  }

  render() {
    return (
      <Tabs defaultActiveKey={1} headerClassName="image-tabs">
        <Tab ref={n => this.stag = n} containerClassName="stag" id="stag" eventKey={1} title="Stag & Hen Parties">
          <h3 className="subheader">Muddy good fun!</h3>
          <p>
            For Stag & Hen parties, our off road days are a perfect way to have your last "lads on tour" moments Chuck the Stag in some deep water or treat the Hen to a perfect mud spa. Have a competition to see <strong>who buys the first round that night</strong> or include some <strong>terrifying forfeits</strong> for the wimps in the group. Fling mud at targets on our vehicles and see who can do the fastest lap around the section... without getting stuck!
          </p>
          <p>
            <strong>Our 4x4 Stag & Hen parties are tailored to your group, so if you want to throw in a surprise or have something special happen on the day - we encourage it!</strong>
          </p>
          <p>
            The course is within easy reach of Bristol, Cardiff and Gloucester; a day of off-roading followed by a night out in some of the UK's best Stag & Hen cities is a no-brainer decision.
          </p>
          <p>
            From {config.halfDayPrice } per person.
          </p>
        </Tab>
        <Tab ref={n => this.offRoad = n} containerClassName="off-road" id="off-road" eventKey={2} title="Off Road Training">
          <h3 className="subheader">Off road skills when they're needed!</h3>
          <p>
            If you use a 4x4 for your job, or your employees are expected to drive off road when needed, we offer extensive training to give them the <strong>confidence and techniques to perform their job safely</strong>. Our instruction can be 1-on-1 or in a group and lasts a full day's training.
          </p>
          <p><strong>Our courses include;</strong></p>
          <ul>
            <li>Introduction to safety aspects of 4x4 and off-road driving.</li>
            <li>Confidently driving through mud and water obstacles.</li>
            <li>Tackling inclines and descending safely.</li>
            <li>Navigating wooded sections.</li>
            <li>Correct assessment of terrain to maintain safety, stability and to prevent roll-overs.</li>
            <li>Basic 4x4 vehicle maintenance.</li>
          </ul>

          <p>
            <strong>If you believe you or your employee may encounter special or severe conditions we can include training for this in our courses.</strong>
          </p>
        </Tab>
        <Tab ref={n => this.birthday = n} containerClassName="birthday" id="birthday" eventKey={3} title="Birthday Parties">
          <h3 className="subheader">Celebrate in style... or mud!</h3>
          <p>
            <strong>Our birthday packages are available as group bookings;</strong> as a full day or a half day. Enjoy a morning of off-roading followed by an afternoon of partying, or celebrate with a full day's 4x4ing and a stop for lunch at the local fantastic farm restaurant. We know how important it is that a birthday party is perfect for the birthday boy/girl, so if you have any special arrangements or surprises, let us know!
          </p>
          <p>
            Birthdays at our off road school are <strong>perfect for petrol-heads</strong> of (almost) all ages. Because our course is off the road, we have no restrictions on whether you have a driving license or not. As long as you can reach the pedals and follow instruction sensibly you can have fun with us.
          </p>
        </Tab>
        <Tab ref={n => this.tailerMade = n} containerClassName="tailer-made" id="tailer-made" eventKey={4} title="Tailer Made Packages">
          <h3 className="subheader"> Off road adventure tailored to you!</h3>
          <p>
            Tailor made packages for any number of people at any skill level.
          </p>
          <p>
            Combine a day's driving with a day's Bush Mechanics to make a weekend of it, One-to-one Competitive Safari race-coaching, a session in your new overland-prepared vehicle or a family party day at our course; complete with picnic.
          </p>
          <p>
            <strong>If you've got an idea for your perfect 4x4 day, we can make it happen.</strong>
          </p>
        </Tab>
      </Tabs>
    );
  }
}

export default PackageTabs;


// WEBPACK FOOTER //
// ./src/components/package-tabs.js